import React from "react";
import { PrimaryButton } from '@softura/fluentuipackage';
import { customThemes } from '@softura/fluentui-themes';

const theme:any = customThemes('MyKomatsu')
const btn = {
    root: {
        background: 'var(--colorPrimary)',
        color: theme.palette.white,
        border: "1px solid var(--colorPrimary)",
        borderRadius: '4px', 
        padding: '0 8px',
        fontSize: '13',

        fontFamily: 'Notosans-Regular',
        '@media (max-width: 667px)': {
          marginTop: '10px',
          marginBottom:'10px',
      }
    },
    rootHovered: {
      backgroundColor: '#3b33b1',
      border: '1px solid #3b33b1'
    },
    rootFocused: {
      backgroundColor: '#3b33b1',
      border: '1px solid #3b33b1'
    },
    rootPressed: {
      backgroundColor: '#3b33b1',
      border: '1px solid #3b33b1'
    },
    label: {
      fontWeight: 'normal'
    }
};
const PrimaryButtons = (props:any) => {
    return(
        <PrimaryButton tabIndex={props?.tabIndex} text={props.text} iconProps={props.searchIcon} styles={btn} onClick={props.onClick} className={props.className} title={props?.title} />    
    )
}

export default PrimaryButtons;